const recommendationsSelector = '.product-recommendations-diffusione';

function updateControls(section) {
  const track = section.querySelector('[data-recommendations-track]');
  const previous = section.querySelector('[data-recommendations-previous]');
  const next = section.querySelector('[data-recommendations-next]');
  if (!track || !previous || !next) return;

  const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
  previous.disabled = track.scrollLeft <= 1;
  next.disabled = track.scrollLeft >= maxScroll - 1;
}

function getStep(track) {
  const card = track.querySelector('.recommendation-card-diffusione');
  const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
  return ((card?.getBoundingClientRect().width || 0) + gap) * 2;
}

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-recommendations-previous], [data-recommendations-next]');
  if (!button) return;

  const section = button.closest(recommendationsSelector);
  const track = section?.querySelector('[data-recommendations-track]');
  if (!section || !track) return;

  const direction = button.hasAttribute('data-recommendations-previous') ? -1 : 1;
  track.scrollBy({ left: direction * getStep(track), behavior: 'smooth' });
  window.setTimeout(() => updateControls(section), 350);
});

document.addEventListener('scroll', (event) => {
  const track = event.target.closest?.('[data-recommendations-track]');
  const section = track?.closest(recommendationsSelector);
  if (section) updateControls(section);
}, true);

const observer = new MutationObserver(() => {
  document.querySelectorAll(recommendationsSelector).forEach(updateControls);
});

observer.observe(document.documentElement, { childList: true, subtree: true });
document.querySelectorAll(recommendationsSelector).forEach(updateControls);
